export const meta = {
  slug: { de: "praxiswebsite-was-patienten-wirklich-suchen", en: "practice-website-what-patients-really-search-for" },
  title: "Was Patienten auf einer Praxiswebsite wirklich suchen",
  excerpt:
    "Die meisten Besucher einer Praxiswebsite haben nur wenige, sehr klare Anliegen. Wer diese ruhig und sichtbar beantwortet, entlastet den Praxisalltag.",
  category: "patienten",
  publishedAt: "2026-04-22",
  updatedAt: "2026-05-06",
  metaTitle: "Praxiswebsite Inhalte – was Patienten erwarten | OnePractix",
  metaDescription:
    "Was Patienten auf einer Praxiswebsite wirklich suchen und wie klare Inhalte den Praxisalltag und die Terminorganisation spürbar entlasten.",
  related: ["online-terminbuchung-wann-sinnvoll", "praxiswebsite-struktur-statt-design"],
  en: {
    title: "What patients really look for on a practice website",
    metaTitle: "What patients look for on practice websites | OnePractix",
    metaDescription:
      "What patients really look for on a practice website and how clear content noticeably relieves daily practice and appointment handling.",
    excerpt:
      "Most visitors to a practice website have only a few, very clear concerns. Answering them calmly and visibly relieves the daily work of the practice.",
  },
};

export default meta;
